import axios from "axios";

const language = document.querySelector('html').getAttribute('lang').substring(0, 2);

const baseUrl = import.meta.env.VITE_BASE_URL + "/" + language + "/api";
// const baseUrl = "https://speck.lufed-it.de/" + language + "/api";

export default {
    async post(url, data) {
      if ((data instanceof FormData) == false) {
        let formData = new FormData();

        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key]) || typeof data[key] === "object") {
            data[key] = JSON.stringify(data[key]);
          }
          
          formData.append(key, data[key]);
        });
        
        data = formData;
      }

      try {
        const response = await axios.post(`${baseUrl}${url}`, data, {
          headers: Object.assign(
            {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            // getAuthHeaders()
          ),
          notifyStatus: true,
        });
    
        return response.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async get(url, data) {
      try {
        const response = await axios.get(`${baseUrl}${url}`, {
          params: data,
        //   headers: getAuthHeaders(),
        });
  
        return response.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  };
